import {
    ChangeDetectorRef,
    Component,
    forwardRef,
    Input,
    ChangeDetectionStrategy,
    inject,
    input,
    output,
} from '@angular/core';
import {
    ControlValueAccessor,
    FormsModule,
    NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { LabelModule } from '@progress/kendo-angular-label';
import { ComboBoxModule } from '@progress/kendo-angular-dropdowns';
import { GeographicalTypes } from '../../constants/geographical-types';

//<!-- FormGroup consumer -->
//<div formGroupName="...">
//    <app-geographic-aggregation-filter formControlName="geographicalAggregation"></app-geographic-aggregation-filter>
//</div>

//<!-- ngModel consumer -->
//<app-geographic-aggregation-filter [(ngModel)]="selectedGeographicalValue"></app-geographic-aggregation-filter>
@Component({
    selector: 'app-geographic-aggregation-filter',
    imports: [FormsModule, LabelModule, ComboBoxModule],
    templateUrl: './geographic-aggregation-filter.component.html',
    styleUrl: './geographic-aggregation-filter.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => GeographicAggregationFilterComponent),
            multi: true,
        },
    ],
})
export class GeographicAggregationFilterComponent implements ControlValueAccessor {
    private cdr = inject(ChangeDetectorRef);

    readonly geographicalTypes = input<string[]>(GeographicalTypes);
    @Input() selectedValue: string = '';
    readonly selectedValueChange = output<string>();

    public isDisabled: boolean = false;
    virtual: any = { itemHeight: 28 };

    private onChange: (value: string) => void = () => {};
    private onTouched: () => void = () => {};

    get internalSelectedValue(): string {
        return this.selectedValue;
    }

    set internalSelectedValue(value: string) {
        if (value !== this.selectedValue) {
            this.selectedValue = value;
            this.onChange(value);
            this.onTouched();
            this.selectedValueChange.emit(value);
        }
    }

    writeValue(value: string): void {
        this.selectedValue = value ?? '';
        this.cdr.markForCheck();
    }

    registerOnChange(fn: (value: string) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    handleBlur(): void {
        this.onTouched();
    }
}
